import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { UiWhiteCard } from "../../_uiComponents/common/UiWhiteCard";
import {
  UiGrayBgLoader,
  UiGrayBgLoaderWithMessage,
} from "../../_uiComponents/common/UiGrayBgLoader";
import { UiDashboardEmptyMessage } from "../../_uiComponents/ErrorMessages/UiEmptyScreens";
import { PawningAccountDetails } from "../../_uiComponents/Accounts/PawningAccountDetails";
import { UiRightSideModal } from "../../_uiComponents/common/UiRightSideModal";
import { UiAccountCard } from "../../_uiComponents/UiAccountCard";
import NumberFormatter from "../../../_helpers/numberFormatter";
import { accountListRequest } from "../../../_redux/_actions/account.actions";
import { commonConstants } from "../../../_redux/_constants";
import ContentLayout from "../Layout/ContentLayout";
import emptyscreenDashboard from "../../../styles/img/empty-accounts-db.png";
import { ReloadIconDark } from "../../../styles/img/svg/ReloadIconDark";
import { UiMobileBottomCard } from "../../_uiComponents/Dashboard/UiMobileBottomCard";

const PawningWrapper = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const [openSideModal, setOpenSideModal] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);

  const { pawningList, customerName, isPawningListLoading, pawningListFail } =
    useSelector((state) => ({
      pawningList: state.account?.accountList?.list,
      customerName: state.account?.customerName,
      isPawningListLoading: state.account?.isAccountListLoading,
      pawningListFail: state.account?.accountListFail,
    }));

  const fetchPawningData = () => {
    dispatch(
      accountListRequest({
        accountType: commonConstants.PAWNING_ACCOUNT_TYPE,
        pageStart: commonConstants.PAGE_START,
        locale: i18n.language,
      }),
    );
  };

  useEffect(() => {
    fetchPawningData();
  }, [dispatch]);

  const handleRetryPawningData = () => {
    fetchPawningData();
  };

  const handleOpenModal = (accNumber) => {
    setSelectedAccount(accNumber);
    setOpenSideModal(true);
  };

  return (
    <>
      <ContentLayout>
        <div className="df-db-left df-mh-wf">
          <UiWhiteCard className="mt-0 df-mh-wf">
            {isPawningListLoading ? (
              <UiGrayBgLoader className="df-ch-130" />
            ) : pawningListFail ? (
              <UiGrayBgLoaderWithMessage
                className="df-act-hist-err m-0 df-pw-60 df-ch-330"
                errorMessage={t(
                  "Sorry, unable to load your pawning accounts.Tap to refresh.",
                )}
                icon={<ReloadIconDark onClick={handleRetryPawningData} />}
              />
            ) : (
              <>
                {Array.isArray(pawningList) && pawningList.length > 0 ? (
                  pawningList.map((item, idx) => (
                    <UiAccountCard
                      key={idx}
                      label1={item?.productName}
                      accountNumber={item?.accountNumber}
                      label2={t("Advance Amount")}
                      isFdCard={true}
                      accountBalance={NumberFormatter(item?.balanceAdvanceAmount)}
                      buttonText={t("Details")}
                      onClick={() => handleOpenModal(item?.accountNumber)}
                    />
                  ))
                ) : (
                  <UiDashboardEmptyMessage
                    icon={emptyscreenDashboard}
                    className="df-fs-empt df-empt-msg-acc"
                  >
                    <h3>
                      {t("Uh-oh!")}
                      <br />
                      {t("No pawning to display")}
                    </h3>
                    <p>
                      {t(
                        "You don't have any pawning to display at the moment.",
                      )}
                    </p>
                  </UiDashboardEmptyMessage>
                )}
              </>
            )}
          </UiWhiteCard>
        </div>
      </ContentLayout>

      <UiRightSideModal
        openSideModal={openSideModal}
        handleClose={() => setOpenSideModal(false)}
      >
        <PawningAccountDetails
          accountNumber={selectedAccount}
          customerName={customerName}
        />
      </UiRightSideModal>

      <UiMobileBottomCard />
    </>
  );
};

export default PawningWrapper;
